export class ReaderViewManager {
  constructor(onTitlePage) {
    this.onTitlePage = onTitlePage
  }

  start() {
    this._setupSkipToContent()
    this._resizeFont()
    this._setupPageState()

    this.panelManager = new PanelManager()
    this.panelManager.start()
    this._attachHandlers()

    if (window.innerWidth < 1000) {
      this.panelManager.closeLeft()
      this.panelManager.closeRight()
    }
  }

  _resizeFont() {
    var fontSize = Math.max(
      50,
      Math.min(200, $.jStorage.get('reader_font_size') || 100)
    )
    $('#bookcontent').css('font-size', `${fontSize}%`) // We need to find a way to use .addClass() here instead
  }

  _setupSkipToContent() {
    if (this.onTitlePage) {
      $('.SkipToMainContentLink').attr('href', '#book_contents')
    }

    // Taken from recipe found here:
    // https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/
    $('.SkipToMainContentLink').on('click', function () {
      $(`#${this.href.split('#')[1]}`)
        .attr('tabindex', -1)
        .on('blur focusout', function () {
          $(this).removeAttr('tabindex')
        })
        .trigger('focus')
      // after focus, scroll the element in view super fast but with
      // an offset so the navbar doesn't cover it
      let focusEl = $('#book_contents').get(0)
        ? $('#book_contents') // title page
        : $('#bookcontent') // book pages
      $('html, body').animate(
        { scrollTop: focusEl.offset().top - 300 },
        10 // Need some time here for some reason.My guess is this is an actual race condition...
      )
    })
  }

  _setupPageState() {
    $('#left_content').scrollTop()
    $('#left_content').scrollTo($('li.toolbar_item.active'))
    $(window).trigger('resize.reader_layout')

    if ($.jStorage.get('leftContent') === 'false') {
      $('#left_content').removeClass('d-block')
      $('#left_content').addClass('d-none')
      $('#left_content').attr('aria-expanded', 'false')
    } else {
      $('#left_content').removeClass('d-none')
      $('#left_content').addClass('d-block')
      $('#left_content').attr('aria-expanded', 'true')
    }

    if ($.jStorage.get('rightContent') === 'false') {
      $('#right_content').removeClass('d-block')
      $('#right_content').addClass('d-none')
      $('#right_content').attr('aria-expanded', 'false')
    } else {
      $('#right_content').removeClass('d-none')
      $('#right_content').addClass('d-block')
      $('#right_content').attr('aria-expanded', 'true')
    }
  }

  _attachHandlers() {
    window.panelManager = this.panelManager

    $(window)
      .off('resize.reader_layout')
      .on('resize.reader_layout', function () {
        if ($(window).width() < 1000) {
          // small screen mode underneath 1000 px width
          this.panelManager.closeLeft()
          this.panelManager.closeRight()
        } else {
          this.panelManager.openLeft()
          this.panelManager.openRight()
        } // if
      })
  }
}

/**
 * Manages the visibility of the Left and Right toolbars on the Reader
 *
 * The open/close state of the panels is persisted between page refreshes by $.jStorage
 */
class PanelManager {
  constructor() {
    this.state = $.jStorage.get('panel-manager-state', {
      leftOpen: true,
      rightOpen: true,
    })
  }

  start() {
    if (!this.state.leftOpen) {
      this.closeLeft()
    }

    if (!this.state.rightOpen) {
      this.closeRight()
    }

    this.attachHandlers()
  }

  /**
   * Update the panel manager's state and persist to browser storage
   */
  setState(newState) {
    this.state = Object.assign({}, this.state, newState)
    $.jStorage.set('panel-manager-state', this.state)
  }

  /**
   * Attach event handlers with delegated listeners so they are immune to DOM changes
   */
  attachHandlers() {
    $('#reader_layout').on('click', '.leftClose', this.closeLeft)
    $('#reader_layout').on('click', '.rightClose', this.closeRight)
    $('#reader_layout').on('click', '.leftOpen', this.openLeft)
    $('#reader_layout').on('click', '.rightOpen', this.openRight)

    $('#reader_layout').on(
      'mouseenter, touchstart',
      '.leftClose',
      this.hoverOnLeftClose
    )
    $('#reader_layout').on(
      'mouseleave, touchend',
      '.leftClose',
      this.hoverOffLeftClose
    )
    $('#reader_layout').on(
      'mouseenter, touchstart',
      '.leftOpen',
      this.hoverOnLeftOpen
    )
    $('#reader_layout').on(
      'mouseleave, touchend',
      '.leftOpen',
      this.hoverOffLeftOpen
    )

    $('#reader_layout').on(
      'mouseenter, touchstart',
      '.rightClose',
      this.hoverOnRightClose
    )
    $('#reader_layout').on(
      'mouseleave, touchend',
      '.rightClose',
      this.hoverOffRightClose
    )
    $('#reader_layout').on(
      'mouseenter, touchstart',
      '.rightOpen',
      this.hoverOnRightOpen
    )
    $('#reader_layout').on(
      'mouseleave, touchend',
      '.rightOpen',
      this.hoverOffRightOpen
    )
  }

  hoverOnLeftClose = () => {
    $('.leftClose')
      .find('.icon')
      .removeClass('icon_menu')
      .addClass('icon_arrow_left')
  }
  hoverOffLeftClose = () => {
    $('.leftClose')
      .find('.icon')
      .addClass('icon_menu')
      .removeClass('icon_arrow_left')
  }
  hoverOnRightClose = () => {
    $('.rightClose')
      .find('.icon')
      .removeClass('icon_menu')
      .addClass('icon_arrow_right2')
  }
  hoverOffRightClose = () => {
    $('.rightClose')
      .find('.icon')
      .addClass('icon_menu')
      .removeClass('icon_arrow_right2')
  }
  hoverOnLeftOpen = () => {
    $('.leftOpen')
      .find('.icon')
      .removeClass('icon_menu')
      .addClass('icon_arrow_right2')
  }
  hoverOffLeftOpen = () => {
    $('.leftOpen')
      .find('.icon')
      .addClass('icon_menu')
      .removeClass('icon_arrow_right2')
  }
  hoverOnRightOpen = () => {
    $('.rightOpen')
      .find('.icon')
      .removeClass('icon_menu')
      .addClass('icon_arrow_left')
  }
  hoverOffRightOpen = () => {
    $('.rightOpen')
      .find('.icon')
      .addClass('icon_menu')
      .removeClass('icon_arrow_left')
  }

  closeLeft = () => {
    $('.leftClose').find('.icon').removeClass('icon_arrow_left')
    $('.leftClose').removeClass('leftClose').addClass('leftOpen')
    $('#reader_content').removeClass('ml-toolbar')
    $('#footer_main').removeClass('ml-lg-toolbar')
    $('.collapse_bar_left').removeClass('resize-w').addClass('resize-e')
    $('#left_content').removeClass('d-block')
    $('#left_content').addClass('d-none')
    $('.navigation_arrow_left').removeClass('NavigationArrow_Left-open')
    $('.navigation_arrow_left').addClass('NavigationArrow_Left-closed')
    $('#left_content').attr('aria-expanded', 'false')
    this.setState({ leftOpen: false })
  }

  closeRight = () => {
    $('.rightClose').find('.icon').removeClass('icon_arrow_right2')
    $('.rightClose').removeClass('rightClose').addClass('rightOpen')
    $('#reader_content').removeClass('mr-toolbar')
    $('.collapse_bar_right').removeClass('resize-e').addClass('resize-w')
    $('#right_content').removeClass('d-block')
    $('#right_content').addClass('d-none')
    $('.navigation_arrow_right').removeClass('NavigationArrow_Right-open')
    $('.navigation_arrow_right').addClass('NavigationArrow_Right-closed')
    $('#right_content').attr('aria-expanded', 'false')
    this.setState({ rightOpen: false })
  }

  openLeft = () => {
    $('.leftOpen').find('.icon').removeClass('icon_arrow_right2')
    $('.leftOpen').removeClass('leftOpen').addClass('leftClose')
    $('#reader_content').addClass('ml-toolbar')
    $('#footer_main').addClass('ml-lg-toolbar')
    $('.collapse_bar_left').removeClass('resize-e').addClass('resize-w')
    $('#left_content').removeClass('d-none')
    $('#left_content').addClass('d-block')
    $('.navigation_arrow_left').removeClass('NavigationArrow_Left-closed')
    $('.navigation_arrow_left').addClass('NavigationArrow_Left-open')
    $('#left_content').attr('aria-expanded', 'true')
    this.setState({ leftOpen: true })
  }

  openRight = () => {
    $('.rightOpen').find('.icon').removeClass('icon_arrow_left')
    $('.rightOpen').removeClass('rightOpen').addClass('rightClose')
    $('#reader_content').addClass('mr-toolbar')
    $('.collapse_bar_right').removeClass('resize-w').addClass('resize-e')
    $('#right_content').removeClass('d-none')
    $('#right_content').addClass('d-block')
    $('.navigation_arrow_right').removeClass('NavigationArrow_Right-closed')
    $('.navigation_arrow_right').addClass('NavigationArrow_Right-open')
    $('#right_content').attr('aria-expanded', 'true')
    this.setState({ rightOpen: true })
  }
}
